import { render, staticRenderFns } from "./FolderImageView.vue?vue&type=template&id=23e72cc7&"
import script from "./FolderImageView.vue?vue&type=script&lang=js&"
export * from "./FolderImageView.vue?vue&type=script&lang=js&"
import style0 from "./FolderImageView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports